import { ReactNode } from "react";

export const Row = ({ left, right }: { left: ReactNode; right: ReactNode }) => {
  return (
    <div className="mt-4 flex gap-4">
      <div className="flex-1">{left}</div>
      <div className="flex-1">{right}</div>
    </div>
  );
};
